import { useState } from "react";
import { esES, enUS } from "@mui/x-data-grid";
import { MyExportButton } from "../components/partner";
import { useTranslation } from "react-i18next";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  transformDivestmentData,
  transformInvestmentData,
} from "../../helpers/exportToExcel";

export const TableLayoutWithDetail = ({
  rows,
  columns,
  title,
  name,
  detail,
}) => {
  const { t, i18n } = useTranslation("global");
  let dataToExcel = [];
  if (title === "positionsClub") {
    dataToExcel = transformInvestmentData(rows, columns, t);
  }
  if (title === "divestmentClub") {
    dataToExcel = transformDivestmentData(rows, columns, t);
  }
  const [pageSize, setPageSize] = useState(25);

  const languageTable =
    i18n.language === "en"
      ? enUS.components.MuiDataGrid.defaultProps.localeText
      : esES.components.MuiDataGrid.defaultProps.localeText;

  return (
    <>
      <DataGridPro
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPage) => setPageSize(newPage)}
        pagination
        localeText={{
          ...languageTable,
          toolbarColumns: t("tableButtons.columns"),
          toolbarDensity: t("tableButtons.density"),
          toolbarExport: t("tableButtons.export"),
        }}
        components={{
          Toolbar: MyExportButton,
        }}
        componentsProps={{ toolbar: { page: title, name, rows, dataToExcel } }}
        sx={{
          border: "0",
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle, .css-cc8tf1": {
            color: "secondary.main", // color diferente en produccion - Comprobar
          },
          "& .MuiDataGrid-cellContent, .css-pdct74-MuiTablePagination-selectLabel, .css-levciy-MuiTablePagination-displayedRows":
            {
              color: "primary.main",
            },
          "& .css-pdct74-MuiTablePagination-selectLabel, .css-levciy-MuiTablePagination-displayedRows":
            {
              color: "secondary.main",
            },
        }}
        getDetailPanelHeight={() => "auto"}
        getDetailPanelContent={({ row }) => detail(row)}
      />
    </>
  );
};
